/* unplugin-vue-components disabled */import { render } from "./FileWord.vue?vue&type=template&id=647d1906"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__